export default __webpack_public_path__ + "static/media/icons_home_new.3fc432d9.svg";